export default __webpack_public_path__ + "static/media/clients 1.8a26c0f8.svg";